import { render, staticRenderFns } from "./CalendarLegend.vue?vue&type=template&id=1277748e&scoped=true"
import script from "./CalendarLegend.vue?vue&type=script&lang=js"
export * from "./CalendarLegend.vue?vue&type=script&lang=js"
import style0 from "./CalendarLegend.vue?vue&type=style&index=0&id=1277748e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1277748e",
  null
  
)

export default component.exports